const COURSERA_DOMAIN = 'coursera.org';

export const isInternalDomain = (href: string): boolean => {
  try {
    const { hostname } = new URL(href);
    return hostname === COURSERA_DOMAIN || hostname.endsWith(`.${COURSERA_DOMAIN}`);
  } catch {
    return false;
  }
};
